import { RunOutputSchema, RunSchema, StoredMessage } from '@/types/schema';
import { getFlattenedArrayOfGenerations } from '@/utils/messages';

export function getPlaygroundChatModelOutput(run: RunSchema) {
  const runOutput = run?.outputs;

  if (!runOutput) return undefined;
  const runGeneration =
    getFlattenedArrayOfGenerations(runOutput)[0] ??
    getFlattenedArrayOfGenerations(runOutput?.output as RunOutputSchema)[0];

  const runOutputMessage =
    runGeneration?.['message'] ??
    (runGeneration?.['text'] != null
      ? { type: 'ai', data: { content: runGeneration?.['text'] } }
      : undefined);

  const output: StoredMessage | RunSchema['outputs'] | undefined =
    runOutputMessage ?? (runOutput?.output as RunSchema['outputs']);

  return output;
}
